export const slug = 'glowingblue-related';